export default "__VITE_PUBLIC_ASSET__94c2a29c__"